import React from "react";

const filterChipBaseClass =
  "min-w-[76px] rounded-[5px] px-3 py-[6px] text-center text-[12px] font-medium transition-colors font-mono";
const filterChipInactiveClass =
  "h-[26px] gap-[12px] font-normal text-[12px] rounded-[5px] border border-[#E5E7EB] py-1 px-3 bg-white text-[#4A5565] hover:bg-[#F3F4F6] text-center justify-center flex items-center";

const filterChipActiveClass = "bg-[#C8C8C8] text-[#4B5563]";

const FilterGroup = ({ title, items, selectedValue, onSelect }) => {
  return (
    <div className="min-w-0">
      <h3 className="mb-4 text-[14px] font-semibold text-[#111827] font-inter">
        {title}
      </h3>

      <div className="grid grid-cols-2 gap-x-3 gap-y-3 sm:grid-cols-3">
        {items.map((item) => {
          const isActive = selectedValue === item;

          return (
            <button
              key={item}
              type="button"
              onClick={() => onSelect(isActive ? "" : item)}
              className={`${filterChipBaseClass} ${
                isActive ? filterChipActiveClass : filterChipInactiveClass
              }`}
            >
              {item}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FilterGroup;
